<template>
<div :class="'popup-container' + getGuestClasses()">
    <input
        type="text"
        autocomplete="off"
        class="input"
        name="guests"
        @click="toggleWindow()"
        :value="$store.state.guestSelector.guestInputValue"
        v-click-outside="hideWindow"
        readonly="true"
    />

    <aside class="ac-notice" v-show="$store.state.defaultState">
        <span class="ac-notice__icon" aria-hidden="true">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="9"
                fill="#776A40"
            >
                <path
                    fill="inherit"
                    d="M8.658 5.033c.474 0 .99.068 1.549.203a5.038 5.038 0 0 1 1.549.66c.474.305.71.652.71 1.042v1.345h-3.25V6.938c0-.745-.355-1.372-1.066-1.88a3.84 3.84 0 0 1 .508-.025Zm-5.865.203a6.606 6.606 0 0 1 1.549-.203c.474 0 .99.068 1.549.203a4.731 4.731 0 0 1 1.523.66c.474.305.711.652.711 1.042v1.345H.533V6.938c0-.39.237-.737.711-1.042.474-.304.99-.524 1.549-.66Zm2.666-1.752a1.48 1.48 0 0 1-1.117.483c-.44 0-.821-.161-1.143-.483a1.562 1.562 0 0 1-.482-1.142c0-.44.16-.821.482-1.143A1.562 1.562 0 0 1 4.342.717c.44 0 .812.16 1.117.482.322.322.482.703.482 1.143 0 .44-.16.82-.482 1.142Zm4.342 0a1.562 1.562 0 0 1-1.143.483c-.44 0-.82-.161-1.142-.483a1.562 1.562 0 0 1-.483-1.142c0-.44.161-.821.483-1.143A1.562 1.562 0 0 1 8.658.717c.44 0 .821.16 1.143.482.321.322.482.703.482 1.143 0 .44-.16.82-.482 1.142Z"
                />
            </svg>
        </span>
        <p class="ac-notice__text">2 adults selected as default. Please change to suit your requirements.</p>
    </aside>

    <div class="popup-window guests-selector" v-show="$store.state.showGuestWindow">
        <div class="modal-arrow">
            <svg width="28" height="18" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill="#FFF" fill-rule="nonzero" d="M2.2 15.6h23.6L14 1z"/><path fill="#FFF" fill-rule="nonzero" d="M2.2 15.6h23.6L14 1.9z"/><path fill="#FFF" d="M0 15.6h28v2H0z"/><path fill="#CCC" fill-rule="nonzero" d="M2.2 15.6L14 1.9l11.8 13.7h1.4L14 .4.8 15.6z"/></g></svg>
        </div>
        <div class="guest-selector__row" :key="index" v-for="(selector, index) in $store.state.guestSelector.selector">
            <div class="guest-selector__label">
                {{ selector.label }}
                <span>{{ selector.helper_text }}</span>
            </div>
            <integer-plusminus :class="{ inputdisabled: !selector.allowed }" :min="selector.min" :max="selector.max" v-model="selector.ipm_value" @input="updateGuestInput" :increment-aria-label="'increase ' + index + ' by 1'" :decrement-aria-label="'decrease ' + index +' by 1'" :spinButtonAriaLabel="index">
                <div :class="'spinbutton__wrap'">
                    {{ selector.ipm_value }}
                </div>
                <template slot="decrement">{{$store.state.guestSelector.ipm_slot_decr}}</template>
                <template slot="increment">{{$store.state.guestSelector.ipm_slot_incr}}</template>
            </integer-plusminus>
        </div>

        <button class="button guests-selector__submit" @click="updateGuestTotals('apply')">Apply</button>
    </div>
</div>
</template>

<script>
import IntegerPlusminus from './IntegerPlusminus'
import ClickOutside from 'vue-click-outside';
import { getCookie } from "../utils/cookie.ts";

export default {
    name: 'GuestDateSelector',
    components: {
        IntegerPlusminus
    },
    directives: {
        ClickOutside
    },
    mounted() {
        let self = this;

        window.addEventListener('keyup', function(event) {
            if (event.keyCode === 27) { // ESC key
                if (self.$store.state.showGuestWindow == true) {
                    self.toggleWindow('guest');
                }
            }
        });

        this.checkForCookieValues();

        this.popupItem = this.$el;
        // this.date_calendars = document.querySelectorAll(".js-calendar-form");
    },
    methods: {
        hasCookieValues: function () {
            const cookie = getCookie("search_cookie__guest");

            return (
                cookie !== null
                && typeof cookie.guests.Adults === 'number'
                && typeof cookie.guests.Children === 'number'
                && typeof cookie.guests.Babies === 'number'
                && typeof cookie.guests.Pets === 'number'
            );
        },
        checkForCookieValues: function () {
            // No guest details have been passed from the search
            if (!this.hasCookieValues()) {
                this.$store.dispatch('setDefaultState', true);
                return;
            }

            const cookieValues = getCookie("search_cookie__guest");

            if (cookieValues.guests.Adults > this.$store.state.guestSelector.selector.adults.max) {
                cookieValues.guests.Adults = this.$store.state.guestSelector.selector.adults.max;
            }

            if (cookieValues.guests.Children > this.$store.state.guestSelector.selector.children.max) {
                cookieValues.guests.Children = this.$store.state.guestSelector.selector.children.max;
            }

            if (cookieValues.guests.Babies > this.$store.state.guestSelector.selector.babies.max) {
                cookieValues.guests.Babies = this.$store.state.guestSelector.selector.babies.max;
            }

            if (cookieValues.guests.Pets > this.$store.state.guestSelector.selector.pets.max) {
                cookieValues.guests.Pets = this.$store.state.guestSelector.selector.pets.max;
            }

            this.$store.state.guestSelector.selector.adults.ipm_value = cookieValues.guests.Adults;
            this.$store.state.guestSelector.selector.children.ipm_value = cookieValues.guests.Children;
            this.$store.state.guestSelector.selector.babies.ipm_value = cookieValues.guests.Babies;
            this.$store.state.guestSelector.selector.pets.ipm_value = cookieValues.guests.Pets;

            this.updateGuestInput();
        },
        toggleWindow: function() {
            this.$store.dispatch('toggleWindow', 'guest');
            // if ( !this.$store.state.showGuestWindow ) {
            //     return;
            // }

            // Close any open date calendars
            // this.date_calendars.forEach((calendar) => {
            //    let modal = calendar.querySelector(".calendar-window");
            //
            //    if ( modal && modal.classList.contains("calendar-window--open") ) {
            //        calendar.querySelector(".daterangepicker-ui").click();
            //    }
            // });
        },
        hideWindow: function(event) {
            //EDGE fallback, for whatever reason v-click-outside doesn't work very well in edge
            if( event.target.className == undefined || event.target.className != 'int-pm-btn int-pm-decrement' && event.target.className != 'int-pm-btn int-pm-increment' ){
                this.$store.dispatch('hideWindow', 'guest');
            }
        },

        /**
         * Has guests selected
         *
         * @return {boolean} Guests?
         */
        hasGuests: function() {
            return ( this.$store.state.requirements.totalGuests > 0 );
        },

        /**
         * User has not supplied any guest details
         *
         * Determines whether or not we are currently showing the default
         * 2 Adult guests, or if the user has supplied their own guest values.
         *
         * @return {boolean} In default state?
         */
        isDefaultState: function () {
            return this.$store.state.defaultState;
        },

        getGuestClasses: function() {
            let classes = '';

            if (this.hasGuests()) {
                classes += ' has-guests';
            }

            return classes;
        },
        updateGuestTotals: function(action) {
            if (action == 'apply') {
                this.$store.dispatch('clearAPiData');
                this.$store.dispatch('toggleWindow', 'guest');
                this.$store.dispatch('calendarSetup');
                this.$store.dispatch('toggleWindow', 'calendar');
                this.$store.dispatch('updateGuestsDatesSummary');

                this.$store.dispatch({
                    type: 'trackGaEvent',
                    eventCategory: 'Availability calendar',
                    eventAction: 'Guest picker applied'
                })

            }
            let guestsTotal = +this.$store.state.guestSelector.selector.adults.ipm_value + +this.$store.state.guestSelector.selector.children.ipm_value;
            this.$store.dispatch('updateAllGuestTotals', guestsTotal);
        },
        updateGuestInput: function() {
            // On the first update, remove the default notice (if visible)
            if (this.isDefaultState()) {
                this.$store.dispatch('setDefaultState', false);
            }

            let guests = this.$store.state.guestSelector.selector;
            let totalGuests = +guests.adults.ipm_value + +guests.children.ipm_value + +guests.babies.ipm_value + +guests.pets.ipm_value;
            if (totalGuests > 0) {
                // Adults
                let guestAdultsText = ((guests.adults.ipm_value > 1) ? ' Adults' : ' Adult');
                let guestsAdults = ((guests.adults.ipm_value > 0) ? guests.adults.ipm_value + guestAdultsText : '');

                // Children
                let guestChildrenText = ((guests.children.ipm_value > 1) ? ' Children' : ' Child');
                let guestsChildren = ((guests.children.ipm_value > 0) ? guests.children.ipm_value + guestChildrenText : '');

                // Babies
                let guestBabiesText = ((guests.babies.ipm_value > 1) ? ' Babies' : ' Baby');
                let guestsBabies = ((guests.babies.ipm_value > 0) ? guests.babies.ipm_value + guestBabiesText : '');

                // Pets
                let guestPetsText = ((guests.pets.ipm_value > 1) ? ' Pets' : ' Pet');
                let guestsPets = ((guests.pets.ipm_value > 0) ? guests.pets.ipm_value + guestPetsText : '');

                // Seperators
                let guestSep1 = ((guests.adults.ipm_value > 0 && (totalGuests - guests.adults.ipm_value) > 0) ? ', ' : '');
                let guestSep2 = ((guests.children.ipm_value > 0 && (+guests.babies.ipm_value + +guests.pets.ipm_value) > 0) ? ', ' : '');
                let guestSep3 = ((guests.babies.ipm_value > 0 && guests.pets.ipm_value > 0) ? ', ' : '');

                // Final output

                let guestInputValue = guestsAdults + guestSep1 + guestsChildren + guestSep2 + guestsBabies + guestSep3 + guestsPets;
                this.$store.dispatch('checkGuestsAgainstTotalCapacity', +guests.adults.ipm_value + +guests.children.ipm_value);
                this.$store.dispatch('updateAllGuestInputValues', guestInputValue);
            }
            this.updateGuestTotals();
            this.$store.dispatch('hideErrorMessage');
            this.$store.dispatch('activateClearState');

            // console.log("Force reload")
            this.$store.dispatch('forceReloadCalendar', true);
            this.$nextTick(() => { this.$store.dispatch('forceReloadCalendar', false) })

        }
    }
}
</script>

<style scoped lang="scss">
    @import "../assets/styles/toolbox.scss";

    input[type="text"] {
        cursor: pointer;
        position: relative;
        z-index: 7;

        @include media(min-width, $bp--app-fixed) {
            border: none;
            z-index: 1;
        }
    }

    .popup-container {
        position: relative;
    }

    .ac-notice {
        background-color: #F6F4EE;
        color: #776A40;
    }

    .popup-window {
        background-color: white;
        padding: rem(24px) rem(16px) rem(16px);

        @include media(min-width, $bp--app-fixed) {
            right: 0;
            padding: rem(18px);
            position: absolute;
        }
    }

    .guests-selector {
        top: rem(38px);
        max-width: none;
        z-index: 6;

        @include media(max-width, $bp--app-fixed - 1px) {
            left: rem(1px);
            right: rem(1px);
        }

        @include media(min-width, $bp--app-fixed) {
            width: rem(340px);
            top: rem(51px);
            border: 1px solid #ccc;
            z-index: 8;
        }

        .modal-arrow {
            display: none;

            @include media(min-width, $bp--app-fixed) {
                width: rem(28px);
                height: rem(18px);
                display: block;
                position: absolute;
                top: (- rem(15.95px));
                right: rem(12px);
            }
        }
    }

    .guest-selector__row {
        display: flex;
        justify-content: space-between;
        margin-bottom: rem(30px);

        &:last-of-type {
            margin-bottom: 0;
        }
    }

    .guest-selector__label {
        color: #757575;
        font-size: rem(16px);
        align-self: center;

        span {
            display: inline-block;
            font-size: rem(10px);
            margin-top: rem(1px);
            display: block;
            color: #757575;
            letter-spacing: 0.5px;
        }
    }

    .guests-selector__submit {
        width: 100%;
        display: block !important;
        margin: rem(30px) auto 0 auto;
        letter-spacing: 0.32px;
        line-height: 1;
        border-radius: 7px;
        padding: rem(12px) rem(8px) rem(9px);
        font-size: rem(17px);
        width: 100%;
        max-width: rem(400px);

        @include media(min-width, $bp--app-fixed) {
            font-size: rem(12px);
            padding: rem(8px);
            max-width: rem(200px);
            margin-top: rem(25px);
        }
    }
</style>

<style lang="scss">
    @import "../assets/styles/toolbox.scss";

    /*
        IntegerPlusMinus component
    */
    .int-pm .int-pm-btn {
        background-color: white !important;
        width: rem(35px) !important;
        height: rem(35px) !important;
        display: inline-block;
        border-radius: 4px;
        border-color: #59717F !important;
        color: #252525;
    }

    .int-pm .int-pm-btn.disabled {
        border-color: #58707E !important;
        opacity: 0.4;
    }

    .int-pm .int-pm-value {
        border: none !important;
        min-width: rem(45px);
        color: #252525;
        font-weight: normal;
        font-size: rem(17px);
    }

    .inputdisabled {
        opacity: 0.7;


        .int-pm .int-pm-btn {
            cursor: not-allowed !important;
            pointer-events:none !important;
        }
    }

    [role="spinbutton"] {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .spinbutton__wrap {
        height: auto;
        line-height: 1;
    }
</style>
